import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SsoContext = createContext();

export const useSso = () => useContext(SsoContext);

export const SsoProvider = ({ children }) => {
  const [ssoInfo, setSsoInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cookies, setCookies] = useState(document.cookie);
  const [authError, setAuthError] = useState(false);
  const [sessionCookie, setSessionCookie] = useState(null);
  const location = useLocation();

  // Helper to check authentication
  const checkAuth = React.useCallback(() => {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocal) {
      // For localhost, get domain from config.json
      fetch('/config.json')
        .then(res => res.json())
        .then(config => {
          const domain = config.DOMAIN ?config.DOMAIN.replace("https://", "").replace("http://", "").replace("-api-explorer", "") : null;
          setSsoInfo({
            companyDetails: {
              baseUrl: 'http://localhost:7012/'
            },
            isAuthenticated: true,
            user: { name: 'Local Dev' }
          });
          setCookies(document.cookie);
          setLoading(false);
          setSessionCookie(null);
          // Optionally, you can store domain in state/context if needed elsewhere
        });
      return;
    }
    fetch('/config.json')
      .then(res => res.json())
      .then(config => {
        const sessionApi = config.API_BASE_URL + 'wolken-secure/session/issessionvalid';
        if (!sessionApi) {
          setAuthError(true);
          setLoading(false);
          return;
        }
        // For non-localhost, use window.location.hostname as domain
        const domain = window.location.hostname.replace("https://", "").replace("http://", "").replace("-api-explorer", "");
        fetch(sessionApi, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'domain': domain
          }
        })
          .then(res => {
            if (!res.ok) {
              setAuthError(true);
              setLoading(false);
              throw new Error('Session check failed');
            }
            // If 200, consider authenticated
            setSsoInfo({ isAuthenticated: true });
            setLoading(false);
          })
          .catch(() => {
            setAuthError(true);
            setLoading(false);
          });
      })
      .catch(() => {
        setAuthError(true);
        setLoading(false);
      });
  }, []);

  // Initial and on route change
  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <SsoContext.Provider value={{ ssoInfo, loading, cookies, authError, sessionCookie }}>
      {children}
    </SsoContext.Provider>
  );
};
